"use client";

import Link from "next/link";
import { ButtonProps } from "@/types/button";
export const Button = ({
  variant = "black",
  text,
  href,
  onClick,
  type = "button",
  disabled = false,
  className = "",
  ariaLabel
}: ButtonProps) => {
  const baseClasses = "rounded-sm border border-solid border-text transition-colors inline-flex items-center justify-center gap-2 text-sm sm:text-base font-poppins px-8 py-2";
  const variantClasses = {
    white: "bg-white text-text hover:bg-text hover:text-white",
    black: "bg-black text-white hover:bg-white hover:text-text",
    transparent: "bg-transparent text-black hover:bg-black hover:text-white"
  };
  const disabledClasses = "opacity-50 cursor-not-allowed";
  const buttonClasses = [baseClasses, variantClasses[variant], disabled ? disabledClasses : "", className].filter(Boolean).join(" ");
  const content = <span dangerouslySetInnerHTML={{
    __html: text
  }}></span>;
  if (href && !disabled) {
    return <Link href={href} className={buttonClasses} aria-label={ariaLabel}>
        {content}
      </Link>;
  }
  return <button type={type} onClick={onClick} disabled={disabled} className={buttonClasses} aria-label={ariaLabel} data-sentry-component="Button" data-sentry-source-file="Button.tsx">
      {content}
    </button>;
};
export default Button;